import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";

import { chosenSites } from "app/common/services/chosenSites";
import type { ILegendItems } from "app/components/React/Legends/legendsTypes";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { IData, ISeries } from "../../types";

import { Bullet, Label } from "./StyledComponents";

const createColorMap = (series: ISeries[]): Record<string, string> => {
    return series.reduce(
        (acc, item) => {
            acc[item.id] = item.color;
            return acc;
        },
        {} as Record<string, string>,
    );
};

export const getInitialLegends = (
    series: ISeries[],
    trafficSourcesMap: Record<string, { text: string; color: string }>,
): ILegendItems => {
    const colorMap = createColorMap(series);
    return Object.entries(trafficSourcesMap).map(([key, item]) => ({
        name: item.text,
        color: colorMap[item.text] || colorsPalettes.carbon[0],
        visible: true,
        data: null,
        id: key,
    }));
};

export const getCategoriesItems = (series: IData[]): ReactNode[] => {
    const sitesForLegend = chosenSites.sitelistForLegend();
    return series.map(({ key }, index) => (
        <CenteredFlexRow
            key={index}
            gap={"8px"}
        >
            <Bullet color={sitesForLegend[index]?.color} />
            <Label>{key}</Label>
        </CenteredFlexRow>
    ));
};
